import React, { useState, useEffect } from 'react';
import socket from '../socket';

const GameBoard = ({ gameSyncData, alertMessage }) => {
    const [currentWord, setCurrentWord] = useState(gameSyncData.game?.currentWord || 'Waiting...');

    const handleSkip = () => {
        socket.emit('skip-cue', { roomId: gameSyncData.roomId });
    };

    useEffect(() => {
        setCurrentWord(gameSyncData.game?.currentWord || 'Waiting...');
    }, [gameSyncData.game?.currentWord]);

    useEffect(() => {
        socket.on('new-cue', (newWord) => {
            setCurrentWord(newWord);
        });

        return () => {
            socket.off('new-cue');
        };
    }, []);

    return (
      <div className="bg-white rounded-3xl px-4 py-6 sm:px-6 sm:py-8 text-center space-y-6 shadow-lg border-4 border-[#022E7E] animate-fadeIn text-xs sm:text-sm md:text-base">
        
        {alertMessage && (
          <p className="text-red-500 text-xs sm:text-sm md:text-base font-medium bg-red-50 border border-red-200 rounded-md px-3 py-2">
            ⚠️ {alertMessage}
          </p>
        )}

        <h3 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-orange-600">
          🎭 You’re the Actor!
        </h3>

        <div className="text-white text-2xl sm:text-4xl md:text-5xl font-extrabold bg-gradient-to-t from-indigo-800 to-indigo-600 px-4 sm:px-6 py-3 sm:py-4 rounded-xl shadow-xl inline-block tracking-wide break-words max-w-full w-full text-center">
          {currentWord}
        </div>

        <p className="text-gray-500 text-sm sm:text-base md:text-lg italic">
          (Act this word without saying it!)
        </p>

          <button
            onClick={handleSkip}
            className="font-bold flex-1 relative inline-block px-3 sm:px-4 py-2 sm:py-3 text-white text-sm sm:text-base md:text-lg 
              bg-[#FFCC21] rounded-2xl shadow-[0_6px_0_0_#FFA600]
              transition-all duration-150 ease-in-out
              hover:scale-[1.03]
              hover:brightness-110
              active:translate-y-[4px] active:shadow-none"
          >
            <span className="text-[#FF1111]">🔁 Skip Cue</span>
          </button>

      </div>
    );


};

export default GameBoard;